import { installCryptoRandomUuidPolyfill } from './cryptoRandomUuidPolyfill';

installCryptoRandomUuidPolyfill();
